import { render } from "./catalog.vue?vue&type=template&id=9380f1e2&scoped=true"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"

import "./catalog.vue?vue&type=style&index=0&id=9380f1e2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9380f1e2"]])

export default __exports__